module.exports = __webpack_public_path__ + "static/media/pic-icon.fd380f36.svg";